<script setup>
const props = defineProps({
	title: {
		type: String,
		required: true,
	},
})
</script>

<template>
	<div class="flex flex-col gap-5 lg:gap-8">
		<div class="flex items-center gap-5">
			<div class="whitespace-nowrap text-sm uppercase text-white/70">{{ title }}</div>
			<div class="h-[1px] w-full border-b border-white/10"></div>
		</div>
		<div class="grid grid-cols-1 gap-5 xl:grid-cols-2">
			<slot />
		</div>
	</div>
</template>
